<template>
	<div
		class="products__item"
		:class="{
			'products__item--special': product.special,
			'products__item--limited': stock > 0,
		}"
	>
		<button
			class="products__item-message"
			ref="message"
			:class="{'products__item-message--added': addedToCart}"
			@click="onCloseMessage"
		>
			<span
				class="products__item-message-text"
				v-html="$t('shoplist.product.successCart')"
			/>
		</button>
		<a
			class="products__item-image"
			@click.prevent="onClick"
		>
			<img
				class="products__item-image-element"
				:src="product.special && product.imageSpecial || product.image"
				alt="Product Image"
				loading="lazy"
			>
		</a>
		<div
			v-if="product.isNewFlavour"
			class="products__item-new"
			v-html="$t('shoplist.product.newFlavour')"
		/>
		<div
			v-else-if="product.isPlanted"
			class="products__item-planted"
		>
			<img
				class="products__item-planted-label"
				:src="productLabelPath('planted')"
				alt="planted label"
			>
		</div>
		<div
			v-else-if="product.isLimited"
			class="products__item-limited"
			v-html="$t('shoplist.product.limitedEdition')"
		/>
		<div class="products__item-container">
			<a
				class="products__item-title"
				@click.prevent="onClick"
			>
				<span
					class="products__item-title-name"
					v-html="product.name"
				/>
				<SVGLabelLeaf
					class="products__item-title-label"
					v-if="product.isVegetarian || product.isVegan"
				/>
				<SVGLabelLeaf
					class="products__item-title-label"
					v-if="product.isVegan"
				/>
			</a>
			<div
				class="products__item-desc"
				v-html="product.shortDescription || product.description"
			/>

			<div
				class="products__item-price"
			>
				<strike
					class="products__item-price-old"
					v-if="originalPrice"
					v-html="$options.filters.madpricecent(originalPrice)"
				/>
				<span
					class="products__item-price-current"
					v-html="$options.filters.madpricecent(price)"
				/>
				<span
					class="products__item-price-unit"
					v-if="product.unit"
					v-html="product.unit"
				/>
			</div>

			<div
				class="products__item-cart"
				v-if="hasBasket"
			>
				<QuantityCounter
					:quantity="quantity"
					base-class="products__item-quantity"
					:class="{
						'products__item-quantity--soldout': !isAvailable,
					}"
					@sub="onSub()"
					@add="onAdd()"
					v-if="!product.isEditable"
					:locked="!isAvailable"
				/>
				<Button
					class="products__item-cart-button"
					:class="{
						'products__item-cart-button--soldout': !isAvailable,
						'btn--no-animation': !isAvailable || locked,
					}"
					@click="onCart()"
					level="primary"
					type="button"
					:text="isAvailable ? $t('shoplist.product.add') : $t('shoplist.product.soldOut')"
					:disabled="locked || !isAvailable"
					:variants="[
						'small'
					]"
				/>
			</div>

			<!-- <div class="products__item-cart">
				<div
					class="products__item-cart-message"
					ref="message"
					:class="{'products__item-cart-message--added': addedToCart}"
					@click="onCloseMessage"
					v-html="$t('shoplist.product.successCart')"
				/>
				<Button
					class="products__item-configure-button"
					@click.prevent="onConfig()"
					level="outline"
					type="button"
					:text="$t('shoplist.product.configButton')"
					:disabled="locked"
					:variants="[
						'small'
					]"
					v-if="product.isConfigurable"
				/>
				<button
					class="products__item-cart-button"
					@click="onCart()"
					:disabled="locked"
					v-else
				>
					<SVGBag/>
				</button>
			</div> -->
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import scrrroll from 'scrrroll';
import genericMixin from '@/mixins/GenericVueMixin';
import QuantityCounter from '@/components/QuantityCounter';
import Button from '@/components/Button';
import MixinProductLabels from "@/mixins/MixinProductLabels";

export default {
	mixins: [
		genericMixin,
		MixinProductLabels,
	],
	components: {
		QuantityCounter,
		Button,
	},
	props: {
		product: Object,
		locked: Boolean,
	},
	data() {
		return {
			quantity: 1,
			selectedVariant: this.product.variants.findIndex(v => v.code == this.product.selectedVariant),
			addedToCart: false,
		};
	},
	computed: {
		...mapGetters('cart', [
			'hasBasket',
		]),
		price() {
			if (this.product.variants.length && this.product.variants.length > this.selectedVariant) {
				return this.product.variants[this.selectedVariant].price;
			}
			return this.product.price;
		},
		originalPrice() {
			let originalPrice = this.product.originalPrice;

			if (this.product.variants.length && this.product.variants.length > this.selectedVariant) {
				originalPrice = this.product.variants[this.selectedVariant].originalPrice;
			}
			return !!originalPrice && this.price < originalPrice && originalPrice;
		},
		priceReduction() {
			if (this.originalPrice) {
				return `-${Math.floor(100 / this.originalPrice * (this.originalPrice - this.price))}%`;
			}
			return false;
		},
		variant() {
			if (this.product.variants.length) {
				if (this.product.variants.length > this.selectedVariant) {
					return this.product.variants[this.selectedVariant];
				}
				return this.product.variants[0];
			}
			else {
				return false;
			}
		},
		availableVariants() {
			// only show variants that have stock
			return this.product.variants.filter(v => v.stock > 0)
		},
		stock() {
			if (this.product.variants.length && this.product.variants.length > this.selectedVariant) {
				if (!isNaN(this.product.variants[this.selectedVariant].stock)) {
					return this.product.variants[this.selectedVariant].stock;
				}
			}
			return this.product.stock;
		},
		isAvailable() {
			return this.stock > 0;
		},
	},
	watch: {
		locked: function (value) {
			if (value) {
				this.onAddedToCart();
			}
		}
	},
	mounted() {
		if (this.product.special) {
			// objectFitImages(this.$refs.largeImage);
		}
	},
	methods: {
		onClick(e) {
			this.$emit('click', this.product.code);
		},
		onSub() {
			this.quantity = Math.max(this.quantity - 1, 1);
			this.$emit('quantitychange', this.quantity);
		},
		onAdd() {
			this.quantity = this.quantity + 1;
			this.$emit('quantitychange', this.quantity);
		},
		onConfig() {
			const item = {
				...this.product,
				price: this.price,
				variant: this.variant.name,
				selectedVariant: this.variant.code,
			}

			this.$emit('config', item);
		},
		onCart() {
			this.addedToCart = false;

			const item = {
				quantity: this.quantity,
				productCode: this.product.code,
				variantCode: this.variant.code
			}
			if (this.product.isEditable) {
				item.forceCopy = true
			}

			this.$emit('addToCart', item);

			this.$nextTick(() => {
				this.quantity = 1;
			});
		},
		onAddedToCart() {
			this.addedToCart = true;

			if (this.$refs.message.getBoundingClientRect().top < scrrroll.offset) {
				scrrroll.to(this.$refs.message, 300);
			}

			clearTimeout(this.messageTimeout);
			this.messageTimeout = setTimeout(() => {
				this.addedToCart = false;
			}, 6000);
		},
		onCloseMessage(e) {
			clearTimeout(this.messageTimeout);
			this.addedToCart = false;
		}
	}
}
</script>

<style>

</style>
